import React from 'react';
import { Box, Button, Flex, Select, Separator, Text, TextField } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';
import { FormField } from 'shared/components';
import { CandidateContactInfoStore } from './candidate-contact-info.store';

type CandidateContactInfoProps = {
   store: CandidateContactInfoStore;
};

const CandidateContactInfoView = ({ store }: CandidateContactInfoProps) => {
   return (
      <Flex direction="column" gap="4">
         {store.showEmailField &&  <FormField label="Електронна пошта" required error={store.emailAddressError}>
            <TextField.Root
               disabled
               size="3"
               value={store.emailAddress}
               onChange={(e) => store.setEmailAddress(e.target.value)}
            />
         </FormField> }
        

         <FormField label="Контактний номер" error={store.contactError}>
            <TextField.Root
               size="3"
               placeholder="+380XXXXXXXXX"
               value={store.contact}
               onChange={(e) => store.setContact(e.target.value)}
            />
         </FormField>

         {store.messengerRows.map((row, index) => {
            const isLastRow = index === store.messengerRows.length - 1;
            const availableOptions = store.getMessengerOptions(index);

            return (
               <Flex key={`messenger-${index}`} direction={{ initial: 'column', md: 'row' }} gap="4" align="end">
                  <Box width={{ initial: '100%', md: '30%' }}>
                     <FormField label="Месенджер">
                        <Select.Root
                           size="3"
                           value={row.type}
                           onValueChange={(value) => store.updateMessengerRow(index, 'type', value)}
                        >
                           <Select.Trigger placeholder="Месенджер" />
                           <Select.Content position="popper">
                              {availableOptions.map((option) => (
                                 <Select.Item key={option} value={option}>
                                    {option}
                                 </Select.Item>
                              ))}
                           </Select.Content>
                        </Select.Root>
                     </FormField>
                  </Box>

                  <Box width={{ initial: '100%', md: '50%' }}>
                     <FormField label={store.getMessengerFieldLabel(row.type)}>
                        <TextField.Root
                           size="3"
                           placeholder={store.getMessengerPlaceholder(row.type)}
                           value={row.link}
                           onChange={(e) => store.updateMessengerRow(index, 'link', e.target.value)}
                        />
                     </FormField>
                  </Box>

                  <Box width={{ initial: '100%', md: '20%' }}>
                     {isLastRow && store.canAddMessengerRow ? (
                        <Button size="3" variant="soft" color="red" onClick={() => store.addMessengerRow()}>
                           Додати ще
                        </Button>
                     ) : store.messengerRows.length > 1 ? (
                        <Button size="3" variant="outline" onClick={() => store.removeMessengerRow(index)}>
                           Видалити
                        </Button>
                     ) : null}
                  </Box>
               </Flex>
            );
         })}

         <Separator my="4" size="4" />

         {store.socialRows.map((row, index) => {
            const isLastRow = index === store.socialRows.length - 1;
            const availableOptions = store.getSocialOptions(index);

            return (
               <Flex key={`social-${index}`} direction={{ initial: 'column', md: 'row' }} gap="4" align="end">
                  <Box width={{ initial: '100%', md: '30%' }}>
                     <FormField label="Соцмережа" required>
                        <Select.Root
                           size="3"
                           value={row.type}
                           onValueChange={(value) => store.updateSocialRow(index, 'type', value)}
                        >
                           <Select.Trigger placeholder="Соцмережа" />
                           <Select.Content position="popper">
                              {availableOptions.map((option) => (
                                 <Select.Item key={option} value={option}>
                                    {option}
                                 </Select.Item>
                              ))}
                           </Select.Content>
                        </Select.Root>
                     </FormField>
                  </Box>

                  <Box width={{ initial: '100%', md: '50%' }}>
                     <FormField label="Посилання на соцмережу">
                        <TextField.Root
                           size="3"
                           value={row.link}
                           placeholder="https://"
                           onChange={(e) => store.updateSocialRow(index, 'link', e.target.value)}
                        />
                     </FormField>
                  </Box>

                  <Box width={{ initial: '100%', md: '20%' }}>
                     {isLastRow && store.canAddSocialRow ? (
                        <Button size="3" variant="soft" color="red" onClick={() => store.addSocialRow()}>
                           Додати ще
                        </Button>
                     ) : store.socialRows.length > 1 ? (
                        <Button size="3" variant="outline" onClick={() => store.removeSocialRow(index)}>
                           Видалити
                        </Button>
                     ) : null}
                  </Box>
               </Flex>
            );
         })}
      </Flex>
   );
};

export const CandidateContactInfo = observer(CandidateContactInfoView);
